import { ChevronRight } from "@faire/slate-icons/ChevronRight";
import { ButtonBase } from "@faire/slate/private/button/ButtonBase";
import { usePolimorphicAttributes } from "@faire/slate/private/button/usePolimorphicAttributes";
import { IActionProps } from "@faire/slate/private/shared/types";
import React, { useId } from "react";

type IProps = {
  actionProps: IActionProps;
};

/**
 * Mobile stand-in for the inline action button: a decorative chevron plus a
 * tap target that covers the whole banner.
 */
export const MessagingBannerTapTarget: React.FC<IProps> = ({ actionProps }) => {
  const labelId = useId();
  const { label, ...buttonProps } = actionProps;
  const { as, linkProps } = usePolimorphicAttributes(buttonProps);
  const { linkTo: _linkTo, replace: _replace, ...nativeProps } = buttonProps;

  return (
    <>
      <span id={labelId} hidden>
        {label}
      </span>
      <ButtonBase
        {...nativeProps}
        {...linkProps}
        as={as}
        className="fs-messaging-banner__tap-target"
        aria-labelledby={labelId}
      />
      <span className="fs-messaging-banner__chevron" aria-hidden>
        <ChevronRight
          width="var(--slate-dimensions-4)"
          height="var(--slate-dimensions-4)"
          color="var(--slate-color-action-icon-default)"
          titleAccess=""
        />
      </span>
    </>
  );
};
